
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/manufacturing",
      function () {
        return require("private-next-pages/cases/manufacturing/index.tsx");
      }
    ]);
  